import React, { useEffect, useState } from "react";
import styles from "../styles/WebinarEvents.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Link from "next/link";
import { useRouter } from "next/router";
import CustomImage from "./CustomImage";
import fetchUtil from "../utils/fetchUtil";

interface WebinarEventsProps {
  headingLevel?: 1 | 2;
}

const WebinarEvents: React.FC<WebinarEventsProps> = ({ headingLevel = 1 }) => {
  const [featuredWebinarsEvents, setFeaturedWebinarsEvents] = useState<any>([]);
  useEffect(() => {
    fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/events?priority_in=one&priority_in=two&priority_in=three`,
      "GET",
      {},
      "",
      false,
    ).then((res: any) => setFeaturedWebinarsEvents(res?.data ?? []));
  }, []);
  const router = useRouter();
  const getPriorityBlog = (priority: string) =>
    featuredWebinarsEvents?.length > 0 &&
    featuredWebinarsEvents.filter((blog: any) => blog.priority === priority);
  const firstPriority =
    getPriorityBlog("one").length > 0 && getPriorityBlog("one")[0];
  const secondPriority =
    getPriorityBlog("two").length > 0 && getPriorityBlog("two")[0];
  const thirdPriority =
    getPriorityBlog("three").length > 0 && getPriorityBlog("three")[0];
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
  };

  return (
    <>
      <div id="shared-webi" className={styles.sharedWebinarComponent}>
        <div className={styles.webinar_events}>
          {headingLevel === 2 ? (
            <h2 className={styles.sectionTitle}>Latest Study Abroad Events</h2>
          ) : (
            <h1 className={styles.sectionTitle}>Latest Study Abroad Events</h1>
          )}
          {/* Desktop view */}
          <div className="d-none d-sm-block">
            <Container>
              <div className={styles.main_webinar_event_div}>
                <Row>
                  {firstPriority && (
                    <Col lg={6} md={6}>
                      <a href={firstPriority?.linkUrl || "/"} aria-label={firstPriority.eventName}>
                        <Card className={styles.webCard}>
                          <div
                            id="event-cardimga"
                            className={styles.event_Card_img}
                          >
                            <CustomImage
                              src={
                                firstPriority?.newlargeImage?.imageUrl ||
                                firstPriority?.largeImage ||
                                "/"
                              }
                              alt={firstPriority?.newlargeImage?.alt}
                              layout="responsive"
                              objectFit="cover"
                              width={570}
                              height={300}
                              className={styles.img}
                            />
                          </div>
                          <Card.Body className={styles.card_body}>
                            <Card.Subtitle className={styles.sub_title}>
                              {firstPriority.date &&
                                `${firstPriority.date} · ${firstPriority.time}`}
                            </Card.Subtitle>
                            <Card.Title className={styles.main_title}>
                              {firstPriority.eventName}
                            </Card.Title>
                            <Card.Text>{firstPriority?.description}</Card.Text>
                            <div className={styles.cardLink}>
                              <Card.Link
                                className={styles.viewMore}
                                href={firstPriority?.linkUrl || "/"}
                              >
                                Register Now
                              </Card.Link>
                            </div>
                          </Card.Body>
                        </Card>
                      </a>
                    </Col>
                  )}
                  <Col lg={6} md={6}>
                    <a href={secondPriority?.linkUrl || "/"} aria-label={secondPriority.eventName}>
                      {secondPriority && (
                        <Card className={styles.event__webinar_card}>
                          <div
                            id="event-cardimgb"
                            className={styles.event_Card_img}
                          >
                            <CustomImage
                              src={
                                secondPriority?.newshortImage?.imageUrl ||
                                secondPriority?.shortImage ||
                                "/"
                              }
                              alt={secondPriority?.newshortImage?.alt}
                              objectFit="cover"
                              width={200}
                              height={250}
                            />
                          </div>
                          <Card.Body className={styles.card_body}>
                            <Card.Subtitle className={styles.sub_title}>
                              {secondPriority &&
                                `${secondPriority.date} · ${secondPriority.time}`}
                            </Card.Subtitle>
                            <Card.Title className={styles.main_title}>
                              {secondPriority.eventName}
                            </Card.Title>
                            <Card.Text>{secondPriority?.description}</Card.Text>
                            <div className={styles.cardLink}>
                              <Card.Link
                                className={styles.viewMore}
                                href={secondPriority?.linkUrl || "/"}
                              >
                                Register Now
                              </Card.Link>
                            </div>
                          </Card.Body>
                        </Card>
                      )}
                    </a>
                    <a href={thirdPriority?.linkUrl || "/"} aria-label={thirdPriority.title || thirdPriority.eventName}>
                      {thirdPriority && (
                        <Card className={styles.event__webinar_card}>
                          <div
                            id="event-cardimgc"
                            className={styles.event_Card_img}
                          >
                            <CustomImage
                              src={
                                thirdPriority?.newshortImage?.imageUrl ||
                                thirdPriority?.shortImage ||
                                "/"
                              }
                              alt={thirdPriority?.newshortImage?.alt}
                              objectFit="cover"
                              width={195}
                              height={250}
                            />
                          </div>
                          <Card.Body className={styles.card_body}>
                            <Card.Subtitle className={styles.sub_title}>
                              {thirdPriority.date &&
                                `${thirdPriority.date} · ${thirdPriority.time}`}
                            </Card.Subtitle>
                            <Card.Title className={styles.main_title}>
                              {thirdPriority.title || thirdPriority.eventName}
                            </Card.Title>
                            <Card.Text>
                              {thirdPriority?.description ||
                                thirdPriority?.aboutSection?.sectionDescription}
                            </Card.Text>
                            <div className={styles.cardLink}>
                              <Card.Link
                                className={styles.viewMore}
                                href={thirdPriority?.linkUrl || "/"}
                              >
                                Register Now
                              </Card.Link>
                            </div>
                          </Card.Body>
                        </Card>
                      )}
                    </a>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
          {/* mobile view */}
          <div className="d-block d-sm-none">
            <Container>
              <Row>
                <Col>
                  <div
                    id="event-webinar"
                    className={styles.main_webinar_event_div}
                  >
                    <Slider {...settings} className={styles.slider}>
                      {featuredWebinarsEvents.map((event: any) => {
                        return (
                          <div>
                            <a href={event?.linkUrl || "/"}>
                              <Card className={styles.webCard}>
                                <div className={styles.event_Card_img}>
                                  <CustomImage
                                    src={
                                      event?.newlargeImage?.imageUrl ||
                                      event?.largeImage ||
                                      "/"
                                    }
                                    alt={event?.newlargeImage?.alt}
                                    layout="responsive"
                                    width={300}
                                    height={200}
                                  />
                                </div>
                                <Card.Body className={styles.card_body}>
                                  <Card.Subtitle className={styles.sub_title}>
                                    {event.date &&
                                      `${event.date} · ${event.time}`}
                                  </Card.Subtitle>
                                  <Card.Title className={styles.main_title}>
                                    {event.eventName}
                                  </Card.Title>
                                  <Card.Text>{event?.description}</Card.Text>
                                  <div className={styles.cardLink}>
                                    <Card.Link
                                      className={styles.viewMore}
                                      href={event?.linkUrl || "/"}
                                    >
                                      Register Now
                                    </Card.Link>
                                  </div>
                                </Card.Body>
                              </Card>
                            </a>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          {router.pathname !== "/events" && router.pathname !== "/webinars" && (
            <Container>
              <Row className={styles.viewMoremrTop}>
                <Col>
                  <Link href={"/events"}>
                    <a className={styles.viewMore} aria-label="See more events">
                      See More
                    </a>
                  </Link>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    </>
  );
};

export default WebinarEvents;
